// extracted by css-extract-rspack-plugin
export default {"googlehero":"ButtonsPage-googlehero_8jS"};